<template>
  <!-- NOTE (TEMPLATE) to show the active proposals -->

  <div class="animated fadeIn">
    <!-- loading component -->
    <Loading />
    <b-modal
      id="fastFinalAccept"
      ref="fastFinalAccept"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center"
      size="md"
    >
      <template v-slot:modal-header>
        <h4>تایید نهایی</h4>
      </template>
      <template v-slot:modal-footer>
        <b-row>
          <b-col cols="1"></b-col>
          <b-col cols="10">
            <!-- NOTE (b-expire) to expiration of the referee -->
            <b-button
              :disabled="busy"
              variant="primary"
              size="lg"
              @click="fastFinalAccept()"
              >تایید نهایی</b-button
            >

            <!-- NOTE (b-cancel) to cancel expiration -->
            <b-button
              variant="warning"
              size="lg"
              class="ml-2"
              @click="hideModal('fastFinalAccept')"
              >لغو عملیات</b-button
            >
          </b-col>
          <b-col cols="1"></b-col>
        </b-row>
      </template>
      <div v-if="selectedRequest.requestTypeEn != 'article'">
        <b-row>
          <b-col>
            <h3 class="m-auto ml-4">وضعیت قرارداد</h3>
            <br />

            <b-form-radio-group row v-model="contract">
              <div class="d-flex" dir="rtl">
                <b-form-radio :value="true"></b-form-radio>
                <label class="ml-2 mt-1"><h6>شامل قرارداد می‌شود</h6></label>
              </div>
              <div class="d-flex" dir="rtl">
                <b-form-radio :value="false"></b-form-radio>
                <label class="ml-2 mt-1"><h6>شامل قرارداد نمی‌شود</h6></label>
              </div>
            </b-form-radio-group>
          </b-col>
          <b-col>
            <h3 class="m-auto ml-4">ناظر</h3>
            <br />

            <b-form-radio-group v-model="haveReferee">
              <div class="d-flex" dir="rtl">
                <b-form-radio :value="true"></b-form-radio>
                <label class="ml-2 mt-1"><h6>ناظر نیاز دارد</h6></label>
              </div>
              <div class="d-flex" dir="rtl">
                <b-form-radio :value="false"></b-form-radio>
                <label class="ml-2 mt-1"><h6>ناظر نیاز ندارد</h6></label>
              </div>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <div v-if="haveReferee">
          <b-form-group label="ناظر مربوطه">
            <v-select
              :reduce="(x) => x.code"
              :options="referees"
              style="direction: rtl"
              v-model="selectedReferee"
            >
              <template v-slot:option="option">
                <div class="text-right">
                  {{ option.label
                  }}<b-badge class="m-1 p-1" variant="info"
                    >کل {{ option.all }}</b-badge
                  ><b-badge class="m-1 p-1" variant="success"
                    >انجام شده {{ option.dones }}</b-badge
                  ><b-badge class="m-1 p-1" variant="danger"
                    >لغو شده {{ option.expireds }}</b-badge
                  ><b-badge class="m-1 p-1" variant="warning"
                    >در جریان {{ option.ongoings }}</b-badge
                  >
                </div>
              </template>
            </v-select>
          </b-form-group>
          <div v-if="selectedReferee.length">
            <div class="mb-2">ناظر انتخاب شده</div>
            <div
              class="selected-referees"
              v-for="(item, index) in computedSelectedReferees"
              :key="index"
            >
              <v-card>
                <v-card-title>{{ item.label }}</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col>داوری‌های دعوت شده: {{ item.all }}</v-col>
                    <v-col>داوری‌های انجام شده: {{ item.dones }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col>داوری‌های در جریان: {{ item.ongoings }}</v-col>
                    <v-col>داوری‌های لغو شده: {{ item.expireds }}</v-col>
                  </v-row>
                  <v-row v-if="item.tags.length != 0">
                    <v-col class="selected-referees__tags">
                      <h6>برچسب‌های داور</h6>
                      <b-badge
                        class="tag"
                        v-for="(tag, index2) in item.tags"
                        :key="index2"
                        variant="primary"
                        >{{ tag }}</b-badge
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </div>
        <hr />
        <div class="d-flex flex-row pt-2">
          <b-form-checkbox style="margin-right: -8px" v-model="isAccelerator">
          </b-form-checkbox>
          <p class="ml-2 mb-2">گزارش‌ها نیاز به تایید شتاب‌دهنده دارند.</p>
        </div>
        <hr />

        <b-form-group label="یادداشت برای پژوهشگر:">
          <b-form-textarea
            trim
            id="textarea"
            aria-describedby="adminMessage"
            v-model="adminMessage"
            width="75%"
            rows="8"
            max-rows="10"
          ></b-form-textarea>
        </b-form-group>
      </div>

      <b-form-group label="نظرات">
        <b-form-textarea
          trim
          id="textarea"
          aria-describedby="description"
          v-model="description"
          width="75%"
          placeholder="نظرات خود را اینجا وارد نمایید"
          rows="8"
          max-rows="10"
        ></b-form-textarea>
      </b-form-group>
      <div v-if="selectedRequest.requestTypeEn != 'article'">
        <h4 class="text-center text-dark">افزودن گزارش</h4>

        <b-button variant="success" class="mb-3 ml-1" @click="addReport()"
          ><strong>افزودن +</strong></b-button
        >
        <b-table
          responsive
          small
          show-empty
          head-variant="light"
          :items="reportItems"
          :fields="reportFields"
          empty-text="رکوردی برای نمایش وجود ندارد"
          class="table table-secondary"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 }}
            </div>
          </template>

          <template v-slot:cell(name)="data">
            <b-form-input
              trim
              v-model="data.item.name"
              type="text"
            ></b-form-input>
          </template>
          <template v-slot:cell(date)="data">
            <datePicker color="#7b1fa2" v-model="data.item.date"></datePicker>
          </template>
          <template v-slot:cell(operation)="data">
            <b-button
              variant="danger"
              class="mr-2"
              @click="removeReport(data.index)"
              >x</b-button
            >
          </template>
        </b-table>
        <hr />
        <h4 class="text-center text-dark">افزودن فایل</h4>

        <b-button variant="success" class="mb-3 ml-1" @click="addFile()"
          ><strong>افزودن +</strong></b-button
        >
        <b-table
          responsive
          small
          show-empty
          head-variant="light"
          :items="fileItems"
          :fields="filesFields"
          empty-text="رکوردی برای نمایش وجود ندارد"
          class="table table-secondary"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 }}
            </div>
          </template>

          <template v-slot:cell(title)="data">
            <b-form-input
              trim
              v-model="data.item.title"
              type="text"
            ></b-form-input>
          </template>
          <template v-slot:cell(date)="data">
            <datePicker color="#7b1fa2" v-model="data.item.date"></datePicker>
          </template>
          <template v-slot:cell(operation)="data">
            <b-button
              variant="danger"
              class="mr-2"
              @click="removeFile(data.index)"
              >x</b-button
            >
          </template>
        </b-table>
      </div>
    </b-modal>
    <b-card
      v-if="$router.currentRoute.path == '/admin/todo/initialAccept'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <p>
        ادمین گرامی؛
        <br />
        حمایت‌های پذیرش اولیه در این بخش نمایش داده میشود.
        <br />
        شما میتوانید روی نام هر حمایت کلیک کنید و وارد جزییات آن شوید. همچنین
        میتوانید با کلیک روی دکمه تایید نهایی، کلیه امور مربوط به تایید نهایی و
        آغاز کنترل پروژه را در همین صفحه انجام دهید.
      </p>
      <h6>
        <hr />
        <b-button
          @click="
            selectedType = 'all';
            currentPage = 1;
          "
          :variant="selectedType == 'all' ? 'primary' : 'outline-primary'"
          class="m-1"
          >همه ({{ items.length }})</b-button
        >
        <b-button
          v-for="type in types"
          :key="type.key"
          @click="
            selectedType = type.key;
            currentPage = 1;
          "
          :disabled="!items.filter((x) => x.requestType == type.key).length"
          :variant="selectedType == type.key ? 'primary' : 'outline-primary'"
          class="m-1"
          >{{ type.title }} ({{
            items.filter((x) => x.requestType == type.key).length
          }})</b-button
        >
        <v-row class="header-box btn-radius pa-1 ps-2" style="margin: 25px 1px">
          <v-col>
            <h4 style="margin-top: 9px">
              {{ selectedType == "all" ? "همه درخواست‌ها" : selectedType }}
            </h4>
          </v-col>
          <v-col>
            <v-btn
              class="bc-primary text-white btn-radius float-end"
              width="200"
              height="45"
              elevation="0"
              :disabled="isBusy || !computedItems.length"
              @click="$refs.table1.$el.click()"
            >
              <span class="fs-small">
                خروجی اکسل

                <v-icon>$Excel</v-icon></span
              >
            </v-btn>
            <vue-excel-xlsx
              v-show="false"
              ref="table1"
              :data="computedItems"
              :columns="excelFields"
              :filename="
                'لیست حمایت های تایید شده (' +
                (selectedType == 'all' ? 'همه درخواست‌ ها' : selectedType) +
                ')'
              "
              :sheetname="currentDate"
            >
              دریافت اکسل
            </vue-excel-xlsx>
          </v-col>
        </v-row>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            class="mt-1"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <!-- NOTE (b-delete) to delete the text of the search bar -->
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h6>

      <!-- NOTE (t-activeProposals) to show the active proposals list -->
      <b-table
        responsive
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="computedItems"
        :current-page="currentPage"
        :per-page="perPage"
        empty-text="رکوردی برای نمایش وجود ندارد"
        empty-filtered-text="رکوردی برای نمایش وجود ندارد"
        striped
        :busy="isBusy"
        :filter="filter"
        @filtered="onFiltered"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(time)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.item.last_update }}
          </div>
        </template>
        <template v-slot:cell(faSubject)="data">
          <div style="text-align: center; vertical-align: middle">
            <a
              v-if="data.item.requestTypeEn == 'project'"
              :href="'/admin/proposal/' + data.item.id"
              target="_blank"
              >{{ data.value }}</a
            >
            <a
              v-else-if="data.item.requestTypeEn == 'phd'"
              :href="'/admin/phdProposal/' + data.item.id"
              target="_blank"
              >{{ data.value }}</a
            >
            <a
              v-else-if="data.item.requestTypeEn == 'master'"
              :href="'/admin/masterProposal/' + data.item.id"
              target="_blank"
              >{{ data.value }}</a
            >
            <a
              v-else-if="data.item.requestTypeEn == 'opportune'"
              :href="'/admin/opportunity/' + data.item.id"
              target="_blank"
              >{{ data.value }}</a
            >
            <a
              v-else-if="data.item.requestTypeEn == 'elite'"
              :href="'/admin/elite/' + data.item.id"
              target="_blank"
              >نخبه وظیفه</a
            >
            <a
              v-else
              :href="'/admin/' + data.item.requestTypeEn + '/' + data.item.id"
              target="_blank"
              >{{ data.value }}</a
            >
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 + perPage * (currentPage - 1) }}
          </div>
        </template>
        <template v-slot:cell(operation)="data">
          <div style="text-align: center; vertical-align: middle; width: 150px">
            <b-button
              variant="success"
              @click="openFinalAccept(data.item)"
              class="text-light"
              >تایید نهایی</b-button
            >
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="selectedType == 'all' ? totalRows : computedItems.length"
        :per-page="perPage"
        first-text="ابتدا"
        prev-text="قبلی"
        next-text="بعدی"
        last-text="آخر"
        align="center"
        size="sm"
        class="my-0"
      ></b-pagination>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  data: function () {
    return {
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      fields: [
        { key: "index", label: "ترتیب" },
        { key: "faSubject", label: "عنوان حمایت" },
        { key: "researcherName", label: "نام پژوهشگر" },
        { key: "requestType", label: "نوع حمایت" },
        { key: "requestsCode", label: "کد طرح" },
        { key: "registerDate", label: "تاریخ ثبت" },
        { key: "university", label: "دانشگاه" },
        { key: "version", label: "نسخه" },
        { key: "lastUpdate", label: "آخرین بروزرسانی", sortable: true },
        { key: "operation", label: "عملیات" },
      ],
      excelFields: [
        { field: "faSubject", label: "عنوان حمایت" },
        { field: "researcherName", label: "نام پژوهشگر" },
        { field: "requestType", label: "نوع حمایت" },
        { field: "requestsCode", label: "کد طرح" },
        { field: "registerDate", label: "تاریخ ثبت" },
        { field: "university", label: "دانشگاه" },
        { field: "version", label: "نسخه" },
        { field: "lastUpdate", label: "آخرین بروزرسانی", sortable: true },
      ],
      types: [
        { key: "طرح پژوهشی", title: "طرح" },
        { key: "رساله دکتری", title: "رساله دکتری" },
        { key: "پایان نامه کارشناسی ارشد", title: "پایان‌نامه ارشد" },
        { key: "مقاله", title: "مقاله" },
        { key: "فرصت مطالعاتی", title: "فرصت مطالعاتی" },
        { key: "نشست تخصصی", title: "نشست تخصصی" },
        { key: "پسادکتری", title: "پسادکتری" },
        { key: "نخبگان وظیفه", title: "نخبگان وظیفه" },
      ],
      items: [],
      filter: "",
      isAccelerator: false,
      selectedType: "all",
      isBusy: true,
      busy: false,
      description: "",
      selectedRequest: {},
      rejectCause: [],
      rejectOptions: [],
      haveReferee: true,
      contract: false,
      referees: [],
      selectedReferee: "",
      adminMessage: "",
      reportDefaults: {
        project: [
          {
            name: "قرارداد",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "نامه پیش پرداخت",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "نامه + گزارش پیشرفت اول",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "نامه + گزارش پیشرفت دوم",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "نامه + گزارش پیشرفت سوم",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "نامه + گزارش پیشرفت نهایی",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "نامه درخواست تمدید قرارداد",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
        ],
        phd: [
          {
            name: "فایل Word  رساله",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "فایل Pdf  رساله",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "فایل Pdf  مقاله مستخرج از رساله  (1)",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "فایل Pdf  مقاله مستخرج از رساله  (2)",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "ثبت اختراع داخلی یا خارجی",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "صورتجلسه دفاع از رساله",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
        ],
        master: [
          {
            name: "فایل Word  پایان نامه",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "فایل Pdf  پایان نامه",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "فایل Pdf  مقاله مستخرج از پایان نامه  (1)",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "فایل Pdf  مقاله مستخرج از پایان نامه  (2)",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "ثبت اختراع داخلی یا خارجی",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "صورتجلسه دفاع از پایان نامه",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
        ],
        postDoc: [
          {
            name: "قرارداد",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "نامه پیش پرداخت",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "نامه + گزارش پیشرفت اول",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "نامه + گزارش پیشرفت دوم",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "نامه + گزارش پیشرفت سوم",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "نامه + گزارش پیشرفت نهایی",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "نامه درخواست تمدید قرارداد",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
        ],
        opportune: [
          {
            name: "نامه درخواست پرداخت",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "گزارش انجام طرح",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "مستندات تحقیقاتی و دستاوردها",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
        ],
        meeting: [
          {
            name: "خلاصه گزارش",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "کتابچه گزارش",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "پوستر",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "فایل اخبار منتشر شده به همراه عکس از نشست",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
        ],
        elite: [
          {
            name: "نامه تائید و اعلام درصد پیشرفت نخبه توسط استاد راهنما",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "فایل  Wordخلاصه گزارش پیشرفت",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "فایل Pdf خلاصه گزارش پیشرفت",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "فایل Word گزارش پیشرفت تفصیلی",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
          {
            name: "فایل Pdf گزارش پیشرفت تفصیلی",
            date: moment(new Date()).format("jYYYY/jMM/jDD"),
          },
        ],
      },
      reportItems: [],
      reportFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      fileItems: [],
      filesFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان فایل" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
    };
  },

  methods: {
    openFinalAccept(item) {
      this.selectedRequest = item;
      this.description = "";
      this.contract = true;
      this.haveReferee = true;
      this.reportItems = this.reportDefaults[item.requestTypeEn];
      this.fileItems = [];
      this.selectedReferee = "";
      this.adminMessage = "";
      this.description = "";
      this.isAccelerator = false;
      this.showModal("fastFinalAccept");
    },
    fastFinalAccept() {
      this.busy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/request/finalAccept",
          {
            requestId: this.selectedRequest.id,
            contract: this.contract ? true : false,
            isReferee: this.haveReferee ? true : false,
            reports: this.reportItems ? this.reportItems : [],
            pcFiles: this.fileItems,
            refereeId: this.haveReferee ? this.selectedReferee : "",
            adminMessage: this.adminMessage,
            isAccelerator: this.isAccelerator,
            description: this.description,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.busy = false;
          this.hideModal("fastFinalAccept");
          this.onMounted();
        })
        .catch((err) => {
          this.busy = false;
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    haveContract() {
      if (this.fileItems.filter((x) => x.title == "قرارداد").length == 0) {
        this.fileItems.unshift({
          title: "قرارداد",
          date: moment(new Date()).format("jYYYY/jMM/jDD"),
        });
      }
    },
    dontHaveContract() {
      if (this.fileItems.filter((x) => x.title == "قرارداد").length != 0) {
        this.fileItems.splice(
          this.fileItems.indexOf(
            this.fileItems.filter((x) => x.title == "قرارداد")[0]
          ),
          1
        );
      }
    },
    addReport() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.reportItems.push({
        name: "گزارش " + Number(this.reportItems.length + 1),
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
      });
    },
    removeReport(order) {
      // NOTE (m-delAchievment) to remove achievments in the relevant sections
      this.reportItems.splice(order, 1);
      const title = (
        <div>
          <h5>حذف گزارش</h5>
          <span>گزارش مورد نظر شما حذف شد</span>
        </div>
      );
      this.toast(title, "error");
    },
    addFile() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.fileItems.push({
        title: "فایل " + Number(this.fileItems.length + 1),
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
      });
    },
    removeFile(order) {
      // NOTE (m-delAchievment) to remove achievments in the relevant sections
      this.fileItems.splice(order, 1);
      const title = (
        <div>
          <h5>حذف فایل</h5>
          <span>فایل مورد نظر شما حذف شد</span>
        </div>
      );
      this.toast(title, "error");
    },
    rejections() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/rejections",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.rejectOptions = [];
          this.rejectOptions.push(
            ...res.data.map((x) => {
              return {
                code: x.id,
                label: x.name,
              };
            })
          );
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    hideModal(id) {
      // NOTE (m-hideModal) to hide modal
      this.$refs[id].hide();
    },
    showModal(id) {
      // NOTE (m-showModal) to show modal
      this.$refs[id].show();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getReferees() {
      this.$http
        .post(
          this.baseUrl + "/setad/admin/reviewers/select",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.referees = [];
          this.referees.push(
            ...res.data.map((x) => {
              return {
                code: x.id,
                label: x.name,
                tags: x.tags,
                all: x.all,
                dones: x.dones,
                ongoings: x.ongoings,
                expireds: x.expireds,
              };
            })
          );
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    onMounted() {
      this.isBusy = true;
      // NOTE (MOUNTED) to show the proposals data
      this.$http
        .post(
          this.baseUrl + "/setad/admin/requests/initialAccept",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items = res.data;
          this.totalRows = this.items.length;
          this.isBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
  },
  computed: {
    computedItems() {
      let filtered = [];
      if (this.selectedType != "all") {
        filtered = this.items.filter((x) => x.requestType == this.selectedType);
      } else {
        filtered = this.items;
      }
      return filtered;
    },
    computedSelectedReferees() {
      let referees = this.referees.filter(
        (x) => this.selectedReferee.indexOf(x.code) != -1
      );
      return referees;
    },
  },
  mounted() {
    if (this.$router.currentRoute.path == "/admin/todo/initialAccept")
      this.onMounted();
    this.getReferees();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../../assets/fonts/IRANSans(FaNum).ttf");
}
.selected-referees {
  border: 1px solid grey;
  border-radius: 5px;
  margin-bottom: 10px;
  &__tags {
    border: 1px solid grey;
    border-radius: 5px;
    padding: 8px 12px;
    .tag {
      padding: 5px;
      margin: 5px;
    }
  }
}

</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
